import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/select';
import { LanguageSettings } from '@src/suite/common/services/language-settings';

const MAX_SYMBOLS = 50;

@Component({
    selector: 'st-attachment-rename',
    imports: [FormsModule, MatButton, MatFormField, MatInput, MatLabel, MatSuffix, ReactiveFormsModule],
    templateUrl: './attachment-rename.html',
    styleUrl: './attachment-rename.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-attachment-rename',
    },
})
export class AttachmentRenameComponent implements OnInit {
    languageSettings = inject(LanguageSettings);
    dialogRef = inject<DialogRef<string>>(DialogRef);
    data = inject<{
        fileName: string;
    }>(DIALOG_DATA);

    attachmentName = new FormControl<string>('');
    public extension = '';
    public maxSymbols: number = MAX_SYMBOLS;

    ngOnInit() {
        this.extractFileNameParts(this.data.fileName);
    }

    private extractFileNameParts(fileName: string) {
        let name = '';
        if (fileName && fileName.length > 0) {
            const extInd = fileName.lastIndexOf('.');
            if (extInd > -1) {
                this.extension = fileName.substring(extInd);
                this.maxSymbols = MAX_SYMBOLS - this.extension.length;
                if (extInd > this.maxSymbols) {
                    name = fileName.substring(0, this.maxSymbols);
                } else {
                    name = fileName.substring(0, extInd);
                }
            } else {
                this.extension = '';
                this.maxSymbols = MAX_SYMBOLS;
            }
        } else {
            this.extension = '';
            this.maxSymbols = MAX_SYMBOLS;
        }
        this.attachmentName.setValue(name);
    }

    public get disabled(): boolean {
        return !this.attachmentName.value || this.attachmentName.value.trim() === '';
    }

    public get fileName(): string {
        return this.attachmentName.value + this.extension;
    }

    renameAttachment() {
        this.dialogRef.close(this.fileName);
    }

    cancel() {
        this.dialogRef.close();
    }
}
